import React from "react";

// Route-level recovery: an exception in any screen renders a calm fallback
// instead of blanking the whole app. Logs a non-sensitive message only.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // Never log financial data or auth secrets; just the component stack.
    console.error("[ThePaycheckEdit] UI error:", error?.message, info?.componentStack?.split("\n")?.[1]?.trim());
  }
  componentDidUpdate(prev) {
    if (this.state.hasError && prev.routeKey !== this.props.routeKey) {
      this.setState({ hasError: false });
    }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-[#FAF8F4] px-6 text-center" data-testid="app-error-boundary">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#C9A86A]">The Paycheck Edit™</p>
          <h1 className="mt-4 font-serif text-3xl text-[#171717]">Something hiccuped.</h1>
          <p className="mt-2 max-w-md text-[#525252]">Your money and your data are safe. Nothing was changed. Let's get you back on track.</p>
          <div className="mt-6 flex gap-3">
            <button onClick={() => { this.setState({ hasError: false }); window.location.assign("/dashboard"); }} data-testid="error-dashboard" className="min-h-11 rounded-xl bg-[#2F6B57] px-6 font-semibold text-white hover:bg-[#255643]">Back to dashboard</button>
            <button onClick={() => window.location.reload()} data-testid="error-reload" className="min-h-11 rounded-xl border border-[#E5E0D9] px-6 font-medium text-[#164C3B] hover:bg-[#F5F2EC]">Reload</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
